import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import FilterForm from './FilterForm';

const EditFilterModal = (props) => {
    const { isOpen, closeBehavior, editFilterBehavior, filterToEdit } = props;

    return (
        <Modal isOpen={isOpen} className="text-light">
            <ModalHeader>Edit Filter</ModalHeader>
            <ModalBody>
                <FilterForm
                    closeBehavior={closeBehavior}
                    addFilterBehavior={editFilterBehavior}
                    filterToEdit={filterToEdit}
                />
            </ModalBody>
        </Modal>
    );
};

export default EditFilterModal;
